import {ExportFileStatus} from './types';

export const INVOICES = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/INVOICES';
export const PAYMENTS = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/PAYMENTS';
export const DEPOSITS = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/DEPOSITS';
export const BILL_PAYERS = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/BILL_PAYERS';
export const DIRECT_DEBITS_AND_CREDITS = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/DIRECT_DEBITS_AND_CREDITS';
export const DIRECT_DEBITS_ALL = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/DIRECT_DEBITS_ALL';
export const DIRECT_DEBITS_NEW = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/DIRECT_DEBITS_NEW';
export const DIRECT_DEBITS_SUBMITTED = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/DIRECT_DEBITS_SUBMITTED';
export const DIRECT_DEBITS_PAID = 'BILLING-ACTIVITY-OVERVIEW/CONSTANTS/DIRECT_DEBITS_PAID';
export const PAYMENT_AND_INVOICES_LIMIT = 100;
export const BILL_PAYER_LIMIT = 50;

export const DIRECT_DEBIT_FORM = 'DIRECT_DEBIT_FORM';
export const DIRECT_CREDIT_FORM = 'DIRECT_CREDIT_FORM';

export const DEPOSIT_STATES = {
    IS_DEPOSITED: 'IS_DEPOSITED',
    NOT_DEPOSITED: 'NOT_DEPOSITED',
    UNKNOWN: 'UNKNOWN',
};

export const VOUCHER_METHOD = 'Voucher';

export const DATE_FORMAT = 'YYYY-MM-DD';

// Payment source type filter on bill payer endpoint on API expects the value 'NOT_SET_UP'
export const NO_ACTIVE_PAYMENT_METHOD = 'NOT_SET_UP';

export enum Entity {
    BillPayers = 'BILL_PAYERS',
}

export const invoiceStatusTextMap = {
    completed: ExportFileStatus.DOWNLOAD,
    pending: ExportFileStatus.LOADING,
    expired: ExportFileStatus.EXPIRED,
};

export const invoiceFormatMap = {
    csv: 'CSV',
    xero: 'Xero CSV',
    sage: 'Sage 200 CSV',
    datev: 'Datev CSV',
};

export const invoiceKeyMap = {
    Invoices: 'invoices',
    'Invoice lines': 'lines',
};
